import React, {useContext, useEffect} from 'react'
import headbandContext from 'contexts/headband'
import Iframe from 'components/iframe/iframe'
export default function ActusIntranet() {
    const {setHeadband} = useContext(headbandContext)
    useEffect(() => {
        setHeadband({
            title :  "Actus intranet",
            icon : "picto_actu_intranet.svg",
            color : "bckGreen"
        })
    }, [])
    return (
        <div className='page'>
            <Iframe url="https://docs.google.com/presentation/d/e/2PACX-1vR_3I7-8I3lyoQeZVZM-NQoU5ww4ERQr9FXfOKSNUV27thMspu4ZSFEUsGeHN5XvmHOj36hI5714MpR/embed?start=true&loop=false&delayms=3000"/>
        </div>
    )
}
